/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Terms_ShortInputs */

const es_ab_terms_short = /** @type {(inputs: Ab_Terms_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos`)
};

const gl_ab_terms_short = /** @type {(inputs: Ab_Terms_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos`)
};

const en_ab_terms_short = /** @type {(inputs: Ab_Terms_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Ab_Terms_ShortInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_terms_short = /** @type {((inputs?: Ab_Terms_ShortInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Terms_ShortInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_terms_short(inputs)
	if (locale === "en") return en_ab_terms_short(inputs)
	return es_ab_terms_short(inputs)
});